import { render, staticRenderFns } from "./species-edit-view.vue?vue&type=template&id=0772f664&scoped=true&"
import script from "./species-edit-view.vue?vue&type=script&lang=js&"
export * from "./species-edit-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0772f664",
  null
  
)

export default component.exports